import React, { useEffect, useState, Suspense, lazy, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Spin,
  Typography,
  notification,
  Modal,
  List,
  Badge,
  Card,
  Tag,
  Tooltip,
  Alert,
  Select,
  Row,
  Col,
  Statistic,
} from "antd";
import {
  SearchOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  ClearOutlined,
} from "@ant-design/icons";
import getVisitaPorTipoAndCodigo from "../../services/visitas_tecnicas/getVisitaPorTipoAndCodigoService";
import Renderizar from "./renderizarReporte";
import obtenerParticipantesPorTecnico from "../../services/participants/getParticipantesPorTecnicoService";
import FormularioActaInicio from "../Visitas/ActaInicio/formularioActaInicio";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../store/auth/selectors";
import config from "../../config";

const baseUrl = config.baseUrl;
const { Text, Title } = Typography;

const Participantes = (title) => {
  const [participants, setParticipants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [showValidacionARN, setShowValidacionARN] = useState(false); // Modal para visitas
  const [showVisitModal, setShowVisitModal] = useState(false); // Estado para visualizar formulario para validación de ARN

  const [tipoVisitas, setTipovisitas] = useState([]); // Lista de visitas

  const [estadoFomulario, setEstadoFormulario] = useState(0); // Visita seleccionada
  const [detalleVisita, setDetalleVisita] = useState(null);
  const [showdetalleVisita, setShowdetalleVisita] = useState(false);
  const selectedTipoVisitaRef = useRef(null); // useRef para mantener el valor de tipo_visita
  const [selectedTipoVisita, setSelectedTipoVisita] = useState(null);

  const usernameFromState = useSelector((state) => state.auth.user);

  const [departamentos, setDepartamentos] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState(null);
  const [selectedMunicipio, setSelectedMunicipio] = useState(null);
  const [selectedEstado, setSelectedEstado] = useState(null);

  const appName = "participantes-paati";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionInsert = permissions.priv_insert === "Y";

  const appName_validacionARN = "validacion_arn";
  const permissions_validacionARN = useSelector((state) =>
    selectAppPermissions(state, appName_validacionARN)
  );
  const permissionAccess_validacionARN =
    permissions_validacionARN.priv_access === "Y";

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  // Mapea las rutas a componentes predefinidos
  const componentMap = {
    FormularioPorPasosDiagnostico: lazy(() =>
      import("../Visitas/Diagnostico/formularioDiagnostico")
    ),
    FormularioConsentimiento: lazy(() =>
      import("../Visitas/Consentimiento/formularioConsentimiento")
    ),
    FormularioPorPasosAnalisisCapacidades: lazy(() =>
      import("../Visitas/AnalisisCapacidades/formularioAnalisisCapacidades")
    ),
    FormularioAutorizacionImagen: lazy(() =>
      import("../Visitas/Autorizacion_imagen/formularioAutorizacion")
    ),
    FormularioActaInicio: lazy(() =>
      import("../Visitas/ActaInicio/formularioActaInicio")
    ),

    FormularioPorPasosMedicionCapacidadesSalida: lazy(() =>
      import(
        "../Visitas/medicionCapacidadesSalida/formMedicionCapacidadesSalida"
      )
    ),
    // Agrega más componentes según sea necesario
  };

  const fetchParticipants = async () => {
    try {
      const response = await obtenerParticipantesPorTecnico(
        usernameFromState.email
      );
      const { estado, participantes, message } = response;

      if (estado) {
        setParticipants(participantes);
        setFilteredData(participantes);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch participants data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "An error occurred while fetching data.",
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchParticipants_locales = async (id_tipo_visita, id_participante) => {
    // Filtro por `participante_oid` y actualizo un detalle específico
    const participanteBuscado = participants.find(
      (p) => p.codigo_sir === id_participante
    );

    if (participanteBuscado) {
      const detalle = participanteBuscado.detalles.find(
        (d) => d.id === id_tipo_visita
      );

      if (detalle) {
        detalle.registrado = "true";
        detalle.estado = "registrado";
      } else {
      }
    } else {
    }

    setSelectedParticipant(participants);
  };

  const fetchVisitaTecnica_locales = async (
    id_tipo_visita,
    id_participante
  ) => {
    const participanteBuscado = participants.find(
      (p) => p.codigo_sir === id_participante
    );

    if (participanteBuscado) {
      const detalle = participanteBuscado.detalles.find(
        (d) => d.id === id_tipo_visita
      );

      if (detalle) {
        const acta = participanteBuscado.detalles.find((d) => d.id === 5);

        if (acta) {
          acta.aprobacionARN = "true";
        }
      } else {
      }
    } else {
    }

    setSelectedParticipant(participants);
  };

  useEffect(() => {
    fetchParticipants();
  }, []);

  useEffect(() => {
    // Obtener lista única de departamentos de los participants
    const uniqueDepartamentos = [
      ...new Set(participants.map((p) => p.departamento)),
    ].sort();
    // Si no hay departamentos asignados, mostrar todos
    setDepartamentos(uniqueDepartamentos);
    setSelectedDepartamento(null);
    setMunicipios([]);
    setFilteredData(participants);
  }, [participants, usernameFromState]);

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    filterData(selectedDepartamento, selectedMunicipio, value, selectedEstado);
  };

  const filterData = (depto, muni, texto, estado) => {
    let filtered = [...participants];

    if (depto) {
      filtered = filtered.filter((p) => p.departamento === depto);
    }

    if (muni) {
      filtered = filtered.filter((p) => p.municipio === muni);
    }

    if (estado) {
      filtered = filtered.filter((p) => p.estado === estado);
    }

    if (texto?.trim()) {
      // Verifica que no sea nulo, vacío o solo espacios
      filtered = filtered.filter((participant) =>
        Object.values(participant).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(texto.toLowerCase())
        )
      );
    }

    setFilteredData(filtered);
  };

  const handleDepartamentoChange = (value) => {
    setSelectedDepartamento(value);
    setSelectedMunicipio(null); // Resetear municipio cuando cambia departamento

    // Obtener municipios del departamento seleccionado
    const municipiosFiltrados = [
      ...new Set(
        participants
          .filter((p) => p.departamento === value)
          .map((p) => p.municipio)
      ),
    ].sort();
    setMunicipios(municipiosFiltrados);

    // Filtrar datos
    filterData(value, null, searchText, selectedEstado);
  };

  const handleMunicipioChange = (value) => {
    setSelectedMunicipio(value);
    filterData(selectedDepartamento, value, searchText, selectedEstado);
  };

  const handleEstadoChange = (value) => {
    setSelectedEstado(value);
    filterData(selectedDepartamento, selectedMunicipio, searchText, value);
  };

  const descargarPdf = async (tipo_visita, codigo) => {
    // Obtener los detalles de la visita
    const responseDetalle = await obtenerDetalleDiagnostico(
      tipo_visita,
      codigo
    );

    if (responseDetalle?.ruta_pdf != null) {
      // 👉 Generar URL con timestamp para evitar caché
      const urlConTimestamp = `${baseUrl}${
        responseDetalle.ruta_pdf
      }?t=${new Date().getTime()}`;

      // Abrir el PDF en una nueva ventana
      window.open(urlConTimestamp, "_blank");
    } else {
      const detalle = {
        ...responseDetalle.detalle,
        fecha_archivo: responseDetalle.fecha_archivo,
      };
      // Establecer el detalle de la visita
      setDetalleVisita(detalle);

      // Actualizar tanto el estado como la referencia
      setSelectedTipoVisita(tipo_visita);
      selectedTipoVisitaRef.current = tipo_visita;

      // Mostrar el detalle de la visita
      setShowdetalleVisita(true);
    }
  };

  // Usar useEffect para asegurarte que el valor de selectedTipoVisita esté actualizado
  useEffect(() => {
    if (selectedTipoVisita) {
    }
  }, [selectedTipoVisita]);

  const SoportesColumn = ({ participant }) => {
    const [tipoVisitasGeneral, setTipovisitasGeneral] = useState(
      participant.detalles
    );
    const [hoveredTag, setHoveredTag] = useState(null);
    const isActaDeInicioAprobadoARN =
      participant.detalles.find((detalle) => detalle.id === 5)
        ?.aprobacionARN === "true";

    const renderTag = (visita, letra) => {
      // Determinar el color para la visita
      const getTagColor = () => {
        if (visita.registrado === "true" && visita.id === 5) {
          return isActaDeInicioAprobadoARN ? "green" : "yellow";
        }
        return visita.registrado === "true" ? "green" : "red";
      };
      return (
        <Tooltip title={visita.visita}>
          <Tag
            color={getTagColor()}
            style={{
              cursor: visita.registrado === "true" ? "pointer" : "not-allowed",
              marginRight: "4px",
              transform:
                hoveredTag === `${visita.id}-${letra}`
                  ? "scale(1.1)"
                  : "scale(1)",
              transition: "transform 0.2s ease",
            }}
            onMouseEnter={() => setHoveredTag(`${visita.id}-${letra}`)}
            onMouseLeave={() => setHoveredTag(null)}
            onClick={() => {
              visita.registrado === "true" &&
                descargarPdf(visita.id, participant.codigo_sir);
            }}
          >
            {visita.registrado === "true" ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )}
            {` ${letra}`}
          </Tag>
        </Tooltip>
      );
    };

    return (
      <>
        {tipoVisitasGeneral.map((visita) => {
          switch (visita.id) {
            case 1:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "C")}
                </React.Fragment>
              );
            case 2:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "D")}
                </React.Fragment>
              );
            case 3:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "AC")}
                </React.Fragment>
              );
            case 4:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "AI")}
                </React.Fragment>
              );
            case 5:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "A")}
                </React.Fragment>
              );
            case 8:
              return (
                <React.Fragment key={visita.id}>
                  {renderTag(visita, "MS")}
                </React.Fragment>
              );
            default:
              return null;
          }
        })}
      </>
    );
  };

  const handleShowVisitModal = async (participant) => {
    setSelectedParticipant(participant);
    // Obtener las visitas asociadas al participante
    setTipovisitas(participant.detalles);
    setShowVisitModal(true);
  };

  const handleValidarARN = async (participant) => {
    setShowValidacionARN(true);
    setSelectedTipoVisita(5);
    const result = await obtenerDetalleDiagnostico(5, participant.codigo_sir);
    // Verificar si la respuesta es exitosa
    if (result.estado === true) {
      // Si la respuesta tiene detalles, establecerlos
      setSelectedParticipant(result.detalle); // Cambié 'detalle' por 'detalles' para que coincida con la respuesta
      setEstadoFormulario(result.estado_formulario);
    }
  };

  const handleSelectVisit = (visit) => {
    setSelectedTipoVisita(visit);
    setShowVisitModal(false); // Cerrar el modal de visitas
    handleShowDetails(selectedParticipant.codigo_sir, visit.id);
  };

  const obtenerDetalleDiagnostico = async (tipo_visita, codigo) => {
    // Obtener los detalles de la visita
    const responseDetalle = await getVisitaPorTipoAndCodigo(
      codigo,
      tipo_visita
    );

    // Establecer el detalle de la visita
    return responseDetalle;
  };

  const handleShowDetails = async (codigo_participante, tipo_visita) => {
    try {
      // Realizar la solicitud para obtener detalles del participante
      const result = await obtenerDetalleDiagnostico(
        tipo_visita,
        codigo_participante
      );
      // Verificar si la respuesta es exitosa
      if (result.estado === true) {
        // Si la respuesta tiene detalles, establecerlos
        const { codigo_pdf, ...detalleSinCodigoPdf } = result.detalle;
        setSelectedParticipant(detalleSinCodigoPdf);
        setEstadoFormulario(result.estado_formulario);
      } else {
        setEstadoFormulario(0);
        // Si no se encuentran detalles, establecer los datos por defecto

        //en caso deque seatipo de visita analisis de capacidades diagnostico parte 2
        if (tipo_visita === 3) {
          const data = await obtenerDetalleDiagnostico(2, codigo_participante);
          if (data.status === 200) {
            setSelectedParticipant({
              id_participante: data.detalle.id_participante,
              codigoPreIni: data.detalle.codigo_pre || "",
              nombre_participante: selectedParticipant.nombre_if,
              nombreProyecto: data.detalle.nombre_proyecto,
              tipoProyecto: data.detalle.asociativo_individual,
              departamento: data.detalle.departamento,
              municipio: data.detalle.municipio,
              lineaProductiva: data.detalle.sector_economico,
            }); // Establecer los datos por defecto si no hay detalles
          } else {
            const data = {
              id_participante: selectedParticipant.codigo_sir,
              nombre_participante: selectedParticipant.nombre_if,
              nombre_proyecto: selectedParticipant.nombre_proyecto,
              codigo_pre: selectedParticipant.codigo_pre,
              codigo_sir: selectedParticipant.codigo_sir,
              actividad_economica_proyecto:
                selectedParticipant.actividad_productiva,
              sector_economico: selectedParticipant.sector,
              municipio: selectedParticipant.municipio,
              departamento: selectedParticipant.departamento,
              paso: 0,
              nombreProyecto: selectedParticipant.nombre_proyecto,
              codigoPreIni: selectedParticipant.codigo_pre,
              lineaProductiva: selectedParticipant.sector,
            };
            setSelectedParticipant(data); // Establecer los datos por defecto si no hay detalles
          }
        } else if (tipo_visita === 8) {
          const data = await obtenerDetalleDiagnostico(3, codigo_participante);
          if (data.status === 200) {
            setSelectedParticipant({
              id_participante: selectedParticipant.codigo_sir,
              nombre_participante: selectedParticipant.nombre_if,
              departamento: selectedParticipant.departamento,
              municipio: selectedParticipant.municipio,
              modalidad_visita: data.detalle.modalidad_visita,
              lugar_visita: data.detalle.lugar_visita,
              latuser: data.detalle.latuser,
              lnguser: data.detalle.lnguser,
              //Datos del paso 2
              quien_responde: data.detalle.quien_responde,
              otro_quien_responde: data.detalle.otro_quien_responde,
              delegado_presenta_documento_pertinente:
                data.detalle.delegado_presenta_documento_pertinente,
              nombre_persona: data.detalle.nombre_persona,
              rango_edad: data.detalle.rango_edad,
              genero: data.detalle.genero,
              estado_embarazo: data.detalle.estado_embarazo,
              nivel_escolaridad: data.detalle.nivel_escolaridad,
              grupo_etnico: data.detalle.grupo_etnico,
              lengua_nativa: data.detalle.lengua_nativa,
              lengua_nativa_no: data.detalle.lengua_nativa_no,
              discapacidad: data.detalle.discapacidad,
              tipo_discapacidad: data.detalle.tipo_discapacidad,
              habilidades_lectoescritoras:
                data.detalle.habilidades_lectoescritoras,
              traductor_acompanante: data.detalle.traductor_acompanante,
              afiliacion: data.detalle.afiliacion,
              convive_actualmente: data.detalle.convive_actualmente,
              otro_convive_actualmente: data.detalle.otro_convive_actualmente,
              horas_actividad_cuidado: data.detalle.horas_actividad_cuidado,
              vive_mismo_lugar_emprendimiento:
                data.detalle.vive_mismo_lugar_emprendimiento,

              //Datos del paso 3
              nombreProyecto: selectedParticipant.nombre_proyecto,
              codigoPreIni: selectedParticipant.codigo_pre || "",
              tipoProyecto: data.detalle.asociativo_individual,
              estadoProyecto: data.detalle.estadoProyecto,
              lineaProductiva: selectedParticipant.sector,
              cambioLineaProductiva: data.detalle.cambioLineaProductiva,
              documento_avala_cambio_diligenciado:
                data.detalle.documento_avala_cambio_diligenciado,
              tenenciaPredio: data.detalle.tenenciaPredio,
              otraTenenciaPredio: data.detalle.otraTenenciaPredio,
              areaPredio: data.detalle.areaPredio,
              zonaPredio: data.detalle.zonaPredio,

              // ✅ Solo incluir si la línea es "Agricola"
              ...(selectedParticipant.sector === "Agrícola" && {
                agricola: {
                  area_produccion:
                    data?.detalle?.agricola?.area_produccion ?? 0,
                  area_bosque: data?.detalle?.agricola?.area_bosque ?? 0,
                  area_predio: data?.detalle?.agricola?.area_predio ?? 0,
                  numero_plantas_sembradas:
                    data?.detalle?.agricola?.numero_plantas_sembradas ?? 0,
                  distancia_sembrada:
                    data?.detalle?.agricola?.distancia_sembrada ?? "",
                  variedad_sembrada:
                    data?.detalle?.agricola?.variedad_sembrada ?? "",
                  meses_siembra: data?.detalle?.agricola?.meses_siembra ?? "",
                  manejo_registros:
                    data?.detalle?.agricola?.manejo_registros ?? "",
                  lista_comercializacion:
                    data?.detalle?.agricola?.lista_comercializacion ?? [],
                },
              }),

              paso: 3,
            }); // Establecer los datos por defecto si no hay detalles
          } else {
            const data = {
              id_participante: selectedParticipant.codigo_sir,
              nombre_participante: selectedParticipant.nombre_if,
              nombre_proyecto: selectedParticipant.nombre_proyecto,
              codigo_pre: selectedParticipant.codigo_pre,
              codigo_sir: selectedParticipant.codigo_sir,
              actividad_economica_proyecto:
                selectedParticipant.actividad_productiva,
              sector_economico: selectedParticipant.sector,
              municipio: selectedParticipant.municipio,
              departamento: selectedParticipant.departamento,
              paso: 0,
              nombreProyecto: selectedParticipant.nombre_proyecto,
              codigoPreIni: selectedParticipant.codigo_pre,
              lineaProductiva: selectedParticipant.sector,
            };
            setSelectedParticipant(data); // Establecer los datos por defecto si no hay detalles
          }
        } else {
          const data = {
            id_participante: selectedParticipant.codigo_sir,
            nombre_participante: selectedParticipant.nombre_if,
            nombre_proyecto: selectedParticipant.nombre_proyecto,
            codigo_pre: selectedParticipant.codigo_pre,
            codigo_sir: selectedParticipant.codigo_sir,
            actividad_economica_proyecto:
              selectedParticipant.actividad_productiva,
            sector_economico: selectedParticipant.sector,
            municipio: selectedParticipant.municipio,
            departamento: selectedParticipant.departamento,
            paso: 0,
            nombreProyecto: selectedParticipant.nombre_proyecto,
            codigoPreIni: selectedParticipant.codigo_pre,
            lineaProductiva: selectedParticipant.sector,
          };
          setSelectedParticipant(data); // Establecer los datos por defecto si no hay detalles
        }
      }

      // Mostrar los detalles
      setShowDetails(true);
    } catch (error) {
      // Manejar el error, por ejemplo, mostrando un mensaje de error
      setSelectedParticipant(null); // Puedes establecer un valor vacío o un mensaje de error
      setShowDetails(false); // O ajustar el estado para no mostrar los detalles si hubo un error
    }
  };

  const handleBackToList = () => {
    setSelectedParticipant(null);
    setShowDetails(false);
    setShowdetalleVisita(false);
    setDetalleVisita(null);
    setSelectedTipoVisita(null);
  };

  const getBackgroundColor = (estado) => {
    switch (estado) {
      case "registrado":
        return "#F6FFED"; // azul claro
      case "pendiente":
        return "#E6F4FF"; // amarillo claro
      case "estado_inicial":
        return "#FFFBE6"; // rojo claro
      case "deshabilitado":
        return "#f5f5f5"; // gris claro
      default:
        return "#ffffff"; // blanco por defecto
    }
  };

  const accionesColumn = {
    title: "Acciones",
    key: "actions",
    render: (text, participant) => {
      const isActaDeInicioRegistrado =
        participant.detalles.find((detalle) => detalle.id === 5)?.registrado ===
        "true";

      const isInactive = participant.estado === "Inactivo";

      return (
        <>
          {permissionInsert && (
            <Tooltip
              title={
                isInactive ? "No disponible porque el estado es Inactivo" : ""
              }
            >
              <Button
                type="primary"
                onClick={() => handleShowVisitModal(participant)}
                disabled={isInactive}
              >
                Registrar
              </Button>
            </Tooltip>
          )}

          {permissionAccess_validacionARN && isActaDeInicioRegistrado && (
            <Tooltip
              title={
                isInactive ? "No disponible porque el estado es Inactivo" : ""
              }
            >
              <Button
                type="primary"
                onClick={() => handleValidarARN(participant)}
                disabled={isInactive}
                style={{ marginLeft: 8 }}
              >
                Validar ARN
              </Button>
            </Tooltip>
          )}
        </>
      );
    },
  };

  // 👉 Construcción dinámica de columnas
  const columns = [
    // solo se agrega "Acciones" si hay permisos
    ...(permissionInsert || permissionAccess_validacionARN
      ? [accionesColumn]
      : []),

    {
      title: "Soportes",
      key: "soportes",
      width: 320,
      render: (text, participant) => (
        <SoportesColumn participant={participant} />
      ),
    },
{
  title: "Estado",
  dataIndex: "estado",
  key: "estado",
  width: 120,
  render: (text) => {
    let color = "red";

    if (text === "Activo") {
      color = "green";
    } else if (text === "Ausente 6 meses") {
      color = "gold";
    }

    return <Tag color={color}>{text}</Tag>;
  },
},
    {
      title: "Nombre",
      dataIndex: "nombre_if",
      key: "nombre_if",
      width: 250,
      fixed: "left",
      ellipsis: true,
      render: (text) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Código SIR",
      dataIndex: "codigo_sir",
      key: "codigo_sir",
      width: 120,
    },
    {
      title: "Sexo",
      dataIndex: "sexo_sir",
      key: "sexo_sir",
    },
    {
      title: "Grupo Etario",
      dataIndex: "grupo_etario",
      key: "grupo_etario",
      width: 150,
    },
    {
      title: "Discapacidad",
      dataIndex: "discapacidad",
      key: "discapacidad",
      width: 130,
    },
    {
      title: "Nombre Proyecto",
      dataIndex: "nombre_proyecto",
      key: "nombre_proyecto",
      width: 150,
    },
    {
      title: "Código PRE",
      dataIndex: "codigo_pre",
      key: "codigo_pre",
    },
    {
      title: "Grupo Territorial",
      dataIndex: "grupo_territorial",
      key: "grupo_territorial",
    },
    {
      title: "Actividad Productiva",
      width: 200,
      dataIndex: "actividad_productiva",
      key: "actividad_productiva",
    },
    {
      title: "Sector",
      dataIndex: "sector",
      key: "sector",
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
    },
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
    },
  ];

  const DynamicComponent =
    selectedTipoVisita && selectedTipoVisita.name_componente
      ? componentMap[selectedTipoVisita.name_componente]
      : null;

  const handleClearFilters = () => {
    // Limpiar el texto de búsqueda y municipio
    setSearchText("");
    setSelectedMunicipio(null);
    setSelectedDepartamento(null);

    if (Array.isArray(usernameFromState?.departamento)) {
      // Si es un array vacío, mostrar todos los participantes
      if (usernameFromState.departamento.length === 0) {
        setSelectedDepartamento(null);
        setMunicipios([]);
        setFilteredData(participants);
      }
      // Si es un array con objetos de departamentos
      else if (typeof usernameFromState.departamento[0] === "object") {
        const userDepartamentos = usernameFromState.departamento.map(
          (d) => d.departamento
        );
        setSelectedDepartamento(null);
        setMunicipios([]);

        const filteredByDepartamentos = participants.filter((participant) =>
          userDepartamentos.includes(participant.departamento)
        );
        setFilteredData(filteredByDepartamentos);
      }
    }
    // Si es un solo departamento (string)
    else if (usernameFromState?.departamento) {
      setSelectedDepartamento(usernameFromState.departamento);

      const municipiosFiltrados = [
        ...new Set(
          participants
            .filter((p) => p.departamento === usernameFromState.departamento)
            .map((p) => p.municipio)
        ),
      ].sort();
      setMunicipios(municipiosFiltrados);

      const filteredByDepartamento = participants.filter(
        (p) => p.departamento === usernameFromState.departamento
      );
      setFilteredData(filteredByDepartamento);
    }
  };

  return (
    <>
      {loading ? (
        <div className="text-center">
          <Spin size="large" />
        </div>
      ) : showDetails ? (
        <div>
          <Suspense
            fallback={
              <div className="text-center">
                <Spin size="large" />
              </div>
            }
          >
            {DynamicComponent ? (
              <DynamicComponent
                initialData={selectedParticipant}
                actionVolver={handleBackToList}
                tipoVisita={selectedTipoVisita.id}
                estado_formulario={estadoFomulario}
                fetchDataLocal={fetchParticipants_locales}
              />
            ) : null}
          </Suspense>
        </div>
      ) : showdetalleVisita ? (
        <Renderizar
          data={detalleVisita}
          tipo_visita={selectedTipoVisita}
          actionVolver={handleBackToList}
        />
      ) : showValidacionARN &&
        selectedParticipant &&
        selectedTipoVisita &&
        estadoFomulario !== null ? (
        <FormularioActaInicio
          initialData={selectedParticipant}
          actionVolver={handleBackToList}
          tipoVisita={5}
          estado_formulario={estadoFomulario}
          fetchDataLocal={fetchParticipants_locales}
          rolAcces="representante_arn"
          fetchVisitaTecnica_locales={fetchVisitaTecnica_locales}
        />
      ) : (
        <>
          <Row gutter={[16, 16]} className="mb-4">
            <Col span={24}>
              <div className="filter-container">
                <Row gutter={[16, 16]} align="middle">
                  {/* Filtro Departamento */}
                  <Col xs={24} sm={12} md={6} lg={5}>
                    <div className="filter-item">
                      <Title
                        level={5}
                        className="filter-label"
                        style={{ color: "#042956" }}
                      >
                        Departamento
                      </Title>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Seleccione departamento"
                        allowClear
                        onChange={handleDepartamentoChange}
                        value={selectedDepartamento}
                        showSearch
                        optionFilterProp="children" // busca dentro del texto de las opciones
                      >
                        {departamentos.map((depto) => (
                          <Select.Option key={depto} value={depto}>
                            {depto}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  {/* Filtro Municipio */}
                  <Col xs={24} sm={12} md={5} lg={4}>
                    <div className="filter-item">
                      <Title
                        level={5}
                        className="filter-label"
                        style={{ color: "#042956" }}
                      >
                        Municipio
                      </Title>
                      <Select
                        style={{ width: "100%" }}
                        placeholder="Seleccione municipio"
                        allowClear
                        disabled={!selectedDepartamento}
                        onChange={handleMunicipioChange}
                        value={selectedMunicipio}
                        showSearch
                        optionFilterProp="children" // busca dentro del texto de las opciones
                      >
                        {municipios.map((muni) => (
                          <Select.Option key={muni} value={muni}>
                            {muni}
                          </Select.Option>
                        ))}
                      </Select>
                    </div>
                  </Col>

                  {/* Filtro Estado */}
                  <Col xs={24} sm={12} md={3} lg={3}>
                    <div className="filter-item">
                      <Title
                        level={5}
                        className="filter-label"
                        style={{ color: "#042956" }}
                      >
                        Estado
                      </Title>
                      <Select
                        style={{ width: "100%" }}
                        allowClear
                        value={selectedEstado}
                        onChange={handleEstadoChange}
                        showSearch
                        optionFilterProp="children" // busca dentro del texto de las opciones
                      >
                        <Select.Option value="Activo">Activo</Select.Option>
                        <Select.Option value="Inactivo">Inactivo</Select.Option>
                        <Select.Option value="Ausente 6 meses">Ausente</Select.Option>

                      </Select>
                    </div>
                  </Col>

                  {/* Barra de búsqueda */}
                  <Col xs={24} sm={12} md={4} lg={5}>
                    <div className="filter-item">
                      <Title
                        level={5}
                        className="filter-label"
                        style={{ color: "#042956" }}
                      >
                        Búsqueda
                      </Title>
                      <Input
                        placeholder="Buscar..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={handleSearch}
                      />
                    </div>
                  </Col>

                  {/* Botón Limpiar */}
                  <Col xs={12} sm={6} md={3} lg={3}>
                    <Button
                      type="primary"
                      onClick={handleClearFilters}
                      icon={<ClearOutlined />}
                      style={{ width: "100%", marginTop: "24px" }}
                      disabled={
                        !!selectedDepartamento &&
                        !searchText &&
                        !selectedMunicipio
                      }
                    >
                      Limpiar
                    </Button>
                  </Col>

                  {/* Total */}
                  <Col xs={12} sm={6} md={3} lg={3}>
                    <Card
                      size="small"
                      style={{
                        marginTop: "24px",
                        textAlign: "center",
                        backgroundColor: "#f0f5ff", // Fondo azul claro
                      }}
                    >
                      <Statistic
                        title="Total Participantes"
                        value={filteredData.length}
                        valueStyle={{
                          color: "#1890ff",
                          fontWeight: "bold",
                        }}
                      />
                    </Card>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>

          <div className="row mb-4">
            <div className="col-12">
              {filteredData.length > 0 ? (
                <Table
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="participante_oid"
                  bordered
                  scroll={{ y: 500, x: "max-content" }}
                  pagination={{
                    current: currentPage, // página actual
                    pageSize: pageSize, // filas por página
                    total: filteredData.length, // total de registros
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"],
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} de ${total} registros`,
                    onChange: (page, size) => {
                      setCurrentPage(page);
                      setPageSize(size);
                    },
                  }}
                />
              ) : (
                <div style={{ textAlign: "center", margin: "20px" }}>
                  <Alert
                    message="No hay resultados"
                    description="No se encontraron participantes que coincidan con tu búsqueda."
                    type="info"
                    showIcon
                  />
                </div>
              )}
            </div>
          </div>
          <Modal
            title="Seleccionar Tipo de Visita"
            open={showVisitModal}
            onCancel={() => setShowVisitModal(false)}
            footer={null}
            style={{ top: 20 }}
          >
            <Card>
              <List
                itemLayout="horizontal"
                dataSource={tipoVisitas}
                renderItem={(visit) => (
                  <List.Item
                    style={{
                      backgroundColor: getBackgroundColor(visit.estado),
                    }}
                  >
                    <List.Item.Meta
                      title={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ flexGrow: 1 }}>
                            <Button
                              type="link"
                              onClick={() => handleSelectVisit(visit)}
                              disabled={visit.estado === "deshabilitado"}
                              style={{ fontSize: "18px", padding: 0 }}
                            >
                              {visit.visita}
                            </Button>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            {visit.estado === "registrado" ? (
                              <Badge
                                status="success"
                                text={
                                  <Text
                                    type="success"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <CheckCircleOutlined
                                      style={{ fontSize: "16px" }}
                                    />{" "}
                                    Registrado
                                  </Text>
                                }
                              />
                            ) : visit.estado === "pendiente" ? (
                              <Badge
                                status="info"
                                text={
                                  <Text
                                    type="primary"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <CheckCircleOutlined
                                      style={{ fontSize: "16px" }}
                                    />{" "}
                                    Pendiente
                                  </Text>
                                }
                              />
                            ) : visit.estado === "estado_inicial" ? (
                              <Badge
                                status="warning"
                                text={
                                  <Text
                                    type="warning"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <EditOutlined
                                      style={{ fontSize: "16px" }}
                                    />{" "}
                                    Estado inicial
                                  </Text>
                                }
                              />
                            ) : (
                              <Badge
                                status="default"
                                text={
                                  <Text
                                    type="secondary"
                                    style={{ fontSize: "16px" }}
                                  >
                                    <CloseCircleOutlined
                                      style={{ fontSize: "16px" }}
                                    />{" "}
                                    Deshabilitado
                                  </Text>
                                }
                              />
                            )}
                          </div>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </Card>
          </Modal>
        </>
      )}
    </>
  );
};

export default Participantes;
